import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "types";
import { adminTemplateState } from "../types/index"
import { initialState } from "./initialState";

const getAdminTemplateState = (state: RootState) => state.adminTemplateState || initialState



export const selectTemplates = createSelector(
    [getAdminTemplateState],
    (adminTemplateState: adminTemplateState) => adminTemplateState.templates 

)

export const selectIsLoading = createSelector(
    [getAdminTemplateState],
    (adminTemplateState: adminTemplateState) => adminTemplateState.isLoading   

)

export const selectError = createSelector(
     [getAdminTemplateState],
    (adminTemplateState: adminTemplateState) => adminTemplateState.error

)

;